import { FC } from 'react';
import { Field } from '@sitecore-jss/sitecore-jss-nextjs';
import classNames from 'classnames';

import { icon_qsg } from '@gn-audio/icons';
import { JabraIcon } from '@gn-audio/jss-components';

import ImageTile from 'common/components/ImageTile/ImageTile';
import { mapSharedPropertiesToFields } from 'common/getters';
import { DictionaryFields, ImageFields, SitecoreFieldTypes } from 'common/types/sitecore';
import { Fields } from 'components/IconTiles/IconTiles';

export type Config = {
  fields: {
    data: {
      item: SitecoreFieldTypes & {
        id: string;
        title: Field<string> & DictionaryFields[''];
        titleShared: Field<string> & DictionaryFields[''];
        bottomText: Field<string> & DictionaryFields[''];
        bottomTextShared: Field<string> & DictionaryFields[''];
      };
    };
  };
};

export type ImageTile = {
  id: string;
  image: ImageFields[''];
  title: Field<string> & DictionaryFields[''];
};

export type BoxContentProps = Fields<'imageTiles', ImageTile & SitecoreFieldTypes>;

const BoxContent: FC<BoxContentProps & Config> = ({ fields }) => {
  if (fields?.errors?.length) {
    return null;
  }
  if (!fields.data.item) {
    return null;
  }

  const config = mapSharedPropertiesToFields<{ title: Field<string>; bottomText: Field<string> }>(
    fields.data.item
  );

  const {
    data: {
      item: {
        imageTiles: { results: imageTiles },
      },
    },
  } = fields;

  const gridClasses =
    imageTiles.length <= 2
      ? 'lg:grid-cols-[repeat(auto-fit,minmax(12.5rem,25%))] xl:grid-cols-[repeat(auto-fit,minmax(12.5rem,25%))]'
      : 'lg:grid-cols-4 xl:grid-cols-4';

  return (
    <div className="container">
      <h2 className="mb-6 text-center text-4xl font-bold leading-[3.25rem] xl:mb-16">
        {config.title.value}
      </h2>
      <div
        className={classNames(
          'grid grid-cols-1 justify-center gap-4 sm:grid-cols-2 md:grid-cols-2',
          gridClasses
        )}
      >
        {imageTiles.map((imageTile) => {
          const item = mapSharedPropertiesToFields<ImageTile>(imageTile);

          return (
            <ImageTile
              key={imageTile.id}
              title={item.title.value}
              image={{
                alt: imageTile.image.jsonValue.value.alt,
                src: imageTile.image.jsonValue.value.src,
              }}
            />
          );
        })}
      </div>
      <div className="mt-4 flex items-center justify-center xl:mt-16">
        <JabraIcon Icon={icon_qsg} className="mr-2 size-10" />
        <span>+ {config.bottomText.value}</span>
      </div>
    </div>
  );
};

export default BoxContent;
